import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { Router } from "react-router-dom";
import { axHistory } from "./resources/axHistory";
import ScrollToTop from "./resources/scrollTop";
ReactDOM.render(
  <React.StrictMode>
    <Router history={axHistory}>
      <ScrollToTop />
      <App />
    </Router>
  </React.StrictMode>,
  document.getElementById("root")
);
